export const logDetails = (debugMode: boolean, props: any) => {
    if (!debugMode) {
        return;
    }
    console.log(props);
};
